import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { trim } from "./text";
import { PUSH_BYPASS_COPY } from "./steps/PushStep";
import { describeAudience } from "./steps/ReviewStep";

// NOTIF-12 AC7/8 — "wide" is exactly the two shapes with no single-workspace
// scope: every user on the platform, or every selected role across every
// workspace. A resolved single workspace (audience_type "workspace" with a
// workspace_id) is narrow — step 4's review is the only gate for that case.
// `workspace_id` is trimmed defensively here (buildPayload.js and
// ReviewStep.js's describeAudience do the same) — the only writer today is a
// real Autocomplete selection, which can't produce whitespace, but a
// whitespace id must never be read as "narrow" if one ever reached this
// state some other way.
export const isWideAudience = (state) =>
  state.audience_type === "all_users" ||
  (state.audience_type === "workspace" && !trim(state.workspace_id));

export default function ConfirmPushDialog({ open, state, onCancel, onConfirm }) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Confirm wide-audience send</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {describeAudience(state)}
        </Typography>
        {state.send_push_notification && (
          <Typography variant="body2">{PUSH_BYPASS_COPY}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Confirm and send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
